import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioSolicitudesSuministroService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEstados(objetoParametrosEntity: ParametrosFiltrosSolicitudSuministrosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'solicitud-suministros/estados',
        [objetoParametrosEntity.codigoBaseDatos]
      );

      return response;

    } catch (e) {
      console.log(`ServicioSolicitudesSumnistrosService.getEstados() ${e}`);
    }

    return null;
  }
  async getMedicamentos(objetoParametrosEntity: ParametrosFiltrosSolicitudSuministrosEntity) {

    try {
      const response = await this.requestUrl.getFilterRequest(
        'solicitud-suministros/medicamentos',
        [objetoParametrosEntity.codigoBaseDatos, { unco_admision_inspecciona: objetoParametrosEntity.uncoAdmisionInspecciona }]
      );

      return response;

    } catch (e) {
      console.log(`ServicioSolicitudesSuminstros.getMedicamentos() ${e}`);
    }
    return null;
  }
  async getEntidadEmpresarial(objetoParametros: ParametrosFiltrosSolicitudSuministrosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad-sp',
        [objetoParametros.codigoBaseDatos, { unco_sede: objetoParametros.uncoSede }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioSolicitudesSuministros.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }
  async getInformacionUsuario(objetoParametros: ParametrosFiltrosSolicitudSuministrosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'informacion-usuario/datos',
        [objetoParametros.codigoBaseDatos, { unco_login: objetoParametros.uncoLogin }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioSolicitudesSuministros.getInformacionUsuario() ${e}`);
    }
    return null;
  }
  async getDataReporte(filtros: FiltrosSolicitudesSuministrosEntity, parametros: ParametrosFiltrosSolicitudSuministrosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-suministros/datos',
        [
          parametros.codigoBaseDatos,
          {
            'unco_admision_inspecciona': parametros.uncoAdmisionInspecciona,
            'unco_medicamentos': filtros.medicamentos,
            'unco_estados_registros': filtros.estadoSolicitud,
          }
        ]);
      return response;

    } catch (e) {
      console.log(`ServicioSolcitudSuministrosService.getDataReporte() ${e}`);
    }
    return null;
  }

}

export interface ParametrosFiltrosSolicitudSuministrosEntity {
  codigoBaseDatos: string;
  uncoAdmisionInspecciona: string;
  uncoSede: string;
  uncoLogin: string;
}
export interface EstadoRegistroEntity {
  unco: string;
  codigo: number;
  descripcion: string;
}
export interface MedicamentosEntity {
  uncoCatalogoSuministroMedicamentos: string;
  descripcionMedicamentos: string;
}
export interface FiltrosSolicitudesSuministrosEntity {
  codigoBaseDatos: string;
  estadoSolicitud: string;
  medicamentos: string;
}
export interface EntidadEmpresarial {
  identificacionTributaria: string;
  digitoVerificacion: string;
  descripcion: string;
  direccion: string;
  telefono: string;
  logoUrl: string;
  codigoPrestador: string;
}
export interface InformacionUsuario {
  nombreUsuario: string;
  codigoBarrasImprime: string;
}
export interface DataSolicitudSuministrosBodyEntity {
  numeroAdmision: string;
  numeroSolicitud: string;
  codigo: string;
  medicamento: string;
  cantidadSolicitada: number;
  cantidadEntregada: number;
  cantidadConsumida: number;
  cantidadDevuelta: number;
  cantidadPendienteDevolucion: number;
}
